import React, { Component } from "react";

const DistribucionLimite = (props) => {

    return (
        <div>
            <div className="row row-bold">
                <div className="col-md-9">
                    <label className="label-primary">{props.Denominacion}</label>
                </div>
                <div className="col-md-3">                   
                    <label className="label-secondary color-azul-claro">{props.Porcentaje}</label>
                    <label className="label-secondary">%</label>
                </div>
            </div>
        </div>
    );
}

export default DistribucionLimite;